import styles from './skeletons.module.css';

/**
 * Phase 6c long-tail PR 9 — placeholder for `<TodayHero />` while
 * `useTodaySession` resolves. Replaces the legacy `HeroTodaySkeleton`
 * (which was shaped like the old dark `<HeroToday />` card).
 *
 * Contract:
 *   - Same outer card shape as `<TodayHero variant="default">` (no
 *     layout shift on swap).
 *   - Light surface (`var(--paper)`) with shadow-sm — matches the new
 *     hero's chrome.
 *   - Neutral placeholder bars only — NEVER flashes another athlete's
 *     "Easy run, 3 miles" before real data resolves (Phase 5 plan
 *     §"Decision 4").
 *   - role="status" + aria-busy="true" so screen readers announce
 *     loading.
 */
export function TodayHeroSkeleton() {
  return (
    <section
      className={styles.todayHeroSkel}
      role="status"
      aria-busy="true"
      aria-label="Loading today's session"
    >
      <div className={styles.todayHeroSkelEyebrowRow}>
        <span className={`${styles.bar} ${styles.todayHeroSkelEyebrow}`} aria-hidden />
        <span className={`${styles.bar} ${styles.todayHeroSkelStreak}`} aria-hidden />
      </div>
      <span className={`${styles.bar} ${styles.todayHeroSkelTitle}`} aria-hidden />
      <span className={`${styles.bar} ${styles.todayHeroSkelTitleLine2}`} aria-hidden />
      <div className={styles.todayHeroSkelMeta}>
        <span className={`${styles.bar} ${styles.todayHeroSkelMetaItem}`} aria-hidden />
        <span className={`${styles.bar} ${styles.todayHeroSkelMetaItem}`} aria-hidden />
        <span className={`${styles.bar} ${styles.todayHeroSkelMetaItem}`} aria-hidden />
      </div>
      <div className={styles.todayHeroSkelFooter}>
        <span className={`${styles.bar} ${styles.todayHeroSkelPill}`} aria-hidden />
        <span className={`${styles.bar} ${styles.todayHeroSkelMetaText}`} aria-hidden />
        <span className={`${styles.bar} ${styles.todayHeroSkelLink}`} aria-hidden />
      </div>
    </section>
  );
}
